import type {
  IConfig,
  SessionNotifications,
  UnresolvedRecord,
} from '../domain/types'
import type { SessionDataArgs } from '../domain/types/session'

export enum LoadersType {
  INITIAL_DATA = 'INITIAL_DATA',
  STORE_CONFIG = 'STORE_CONFIG',
  CREATE_ORDER = 'CREATE_ORDER',
}

/** A loader is either just a name, or a name with how long to hold the spinner. */
export type LoaderConfig = string | { name: string; delay: number }

export enum ErrorMessageTranslation {
  GetCart = 1,
  CatalogueEmptyData,
  InitialData,
  NonProvidedParams,
  ErrorOnInitialLoad,
}

export interface IParams
  extends Record<string, string | UnresolvedRecord | undefined> {
  location?: {
    pathname: string
  }
}

/**
 * cinnamon's `ISliceDefault`, minus everything that belonged to the config
 * interpreter this project replaces.
 *
 * Dropped, and why:
 * - `modals`, `dialogs`, `currentModalItem` — string-keyed containers addressed
 *   by the JSON component tree. Typed pages open their own dialogs.
 * - `validators`, `excludedUiComponents` — the DSL's way of switching components
 *   on and off from config.
 * - `cartAlerts`, `alerts` — checkout-rule surfacing, out of scope for this
 *   slice. `IAlert` also extends MUI's `SnackbarProps`, so it cannot enter core.
 * - `onErrorCallback` — a function held in Redux state. Non-serializable, and
 *   its only producer paired it with a full page reload.
 *
 * See docs/NOT_PORTED.md.
 */
export interface ConfigState {
  loaders: string[]
  loading: boolean
  loadingDelay: number
  config?: IConfig
  sessionId?: string
  storeName?: string
  sessionData?: SessionDataArgs
  errorMessage?: string | null
  globalError: boolean
  showErrorTitle: boolean
  params: IParams
  secondaryLoader?: boolean
  showRecommendations: boolean
  showSuggestedItems: boolean
  sessionNotifications?: Record<SessionNotifications, boolean>
}
